/**
* Chartjs plugin to create a property fillCb, a callback property,
* to allow the fill property to be scriptable.
* The fillCb function is called with the chart instance as the first argument and the 
* fill for the dataset will be set to the return value of the fillCb.
*
* See the chartjs plugin docs to better understand the API:
* https://www.chartjs.org/docs/developers/plugins.html
*
*/

export const fillCb = {
  id: 'fillCb',

  beforeUpdate(chart, _args, options) {
    if (!options || !options.enabled) {
      return;
    }
    const datasets = chart.config.data.datasets;

    // Iterate through each dataset and check if it has a "fillCb" property.
    datasets.forEach((dataset, _datasetIndex) => {
      if (dataset.fillCb) {
        const fill = dataset.fillCb(chart)
        dataset.fill = fill
      }
    });
  }
}
